import React from 'react';

import { iconStyle } from './../common/styles';

import { CellPluginComponentProps } from '../../../../editor';
import lazyLoad from '../../../../editor/core/helper/lazyLoad';
import type { ImageState } from '../types/state';

const ImageIcon = lazyLoad(() => import('@mui/icons-material/Landscape'));

const ImageHtmlRenderer: React.FC<CellPluginComponentProps<ImageState>> = (
  props
) => {
  const { data } = props;

  const src = data?.src;
  const alt = data?.alt;
  const openInNewWindow = data?.openInNewWindow;

  const align = data?.align ?? 'left';

  const image = (
    <img
      className="react-page-plugins-content-image"
      alt={alt}
      src={src}
      // The width is set from the image Controls panel. It overrides the class's
      // width:100%; height auto + maxWidth 100% keep the aspect ratio and
      // responsiveness. Legacy images (no width) keep the full-width behavior.
      // Applied in both edit and view mode so the canvas reflects the size live.
      // inline-block lets the wrapper's text-align position it (left/center/right).
      style={
        data?.width
          ? {
              width: data.width,
              height: 'auto',
              maxWidth: '100%',
              display: 'inline-block',
            }
          : undefined
      }
    />
  );

  return src ? (
    // text-align aligns the (inline-block) image or its link wrapper. Only has a
    // visible effect once the image is narrower than the container (width set).
    <div style={{ textAlign: align }}>
      {data?.href ? (
        <a
          onClick={props.isEditMode ? (e) => e.preventDefault() : undefined}
          href={data?.href}
          target={openInNewWindow ? '_blank' : undefined}
          rel={openInNewWindow ? 'noreferrer noopener' : undefined}
        >
          {image}
        </a>
      ) : (
        image
      )}
    </div>
  ) : (
    <div>
      <div className="react-page-plugins-content-image-placeholder">
        <ImageIcon style={iconStyle} />
      </div>
    </div>
  );
};

export default ImageHtmlRenderer;
